// extracted by css-extract-rspack-plugin
export default {"QuestionListItemRoot":"QuestionListItem-module__QuestionListItemRoot___IfUBi","CheckboxContainer":"QuestionListItem-module__CheckboxContainer___RMgSM"};